module.exports = __webpack_public_path__ + "img/sign-out.df57a0e7.svg";